import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const CountryLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 7px 8px;
  justify-content: center;
  background: rgba(217, 219, 223, 1);
  gap: 4px;
  border-radius: 8px;
  margin: 0 8px;
  img {
    border-radius: 50%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.grey000};
`;

export const BackButton = styled.div`
  display: flex;
  width: 36px;
  height: 36px;
  margin-right: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey300};
  background: ${({ theme }) => theme.colors.grey100};
  cursor: pointer;

  &:after {
    content: '\\e913';
    transform: rotate(90deg);
    font-family: 'Icomoon';
  }
`;

export const PageName = styled(typography.LargeTitleTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const UserNameWrapper = styled.div`
  position: relative;
  margin-inline-start: auto;
  cursor: pointer;
`;

export const UserName = styled(typography.BodyTextOneRegularTypography)`
  display: flex;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};

  &:after {
    content: '\\e913';
    font-family: 'Icomoon';
    margin-inline-start: 6px;
  }
`;

export const LogoutPopup = styled.div`
  position: absolute;
  top: 25px;
  width: 100%;
  padding: 4px 0;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-shadow: 0px 4px 16px rgb(0 0 0 / 16%);
  z-index: 1;
`;

export const Logout = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.black};

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;

export const BreadCrumbWrapper = styled.div`
  display: flex;
  padding: 5px 16px;
  align-items: center;
`;

export const BreadCrumb = styled(typography.BodyTextThreeRegularTypography)`
  margin: 0;
  cursor: pointer;

  ${({ isFirst }) => (isFirst ? 'margin-right: 8px' : 'margin: 0 8px')};

  &:hover {
    color: ${({ theme }) => theme.colors.blueMain};
    text-decoration: underline;
  }
`;
